import {BedTypes} from "@hosttools/core/models/listing.constant";
import {
    ButtonIconTooltip,
    CheckIcon,
    CloseIcon,
    FormField,
    HStack,
    Input,
    InputField,
    SelectGeneric,
    useNumberInputRules
} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";
import {Controller, useForm} from "react-hook-form";

import type {Bed} from "../type";

import {TableCell, TableRow} from "@/client/components/Table";

type Props = {
    bed: Partial<Bed>;
    index?: number;
    onChange: (bed: Bed, index?: number) => void;
    onCancel: () => void;
};

const BedForm: React.FC<Props> = ({bed, index, onChange, onCancel}) => {
    const {
        control,
        register,
        handleSubmit,
        formState: {errors}
    } = useForm<Bed>({
        defaultValues: bed
    });

    const inputNumberRules = useNumberInputRules();

    const handleSaveBed = useCallback(
        (bed: Bed) => {
            onChange(bed, index);
        },
        [index, onChange]
    );

    return (
        <TableRow>
            <TableCell>
                <FormField error={errors?.bedType?.message}>
                    <Controller
                        control={control}
                        name="bedType"
                        render={({field}) => {
                            return (
                                <SelectGeneric
                                    options={BedTypes}
                                    placeholder="Select type..."
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            );
                        }}
                        rules={{
                            required: "This field is required"
                        }}
                    />
                </FormField>
            </TableCell>
            <TableCell>
                <FormField error={errors?.count?.message}>
                    <Input isRequired>
                        <InputField
                            id="bedCount"
                            placeholder="Count...."
                            testID="input-bed-count"
                            type="number"
                            {...register("count", {
                                ...inputNumberRules,
                                required: "Please enter count."
                            })}
                        />
                    </Input>
                </FormField>
            </TableCell>
            <TableCell align="end">
                <HStack className="items-center justify-end" space="xs">
                    <ButtonIconTooltip
                        action="primary"
                        icon={CheckIcon}
                        testID="btn-tick-icon"
                        tooltip="Save"
                        onPress={handleSubmit(handleSaveBed)}
                    />
                    <ButtonIconTooltip
                        action="negative"
                        icon={CloseIcon}
                        testID="btn-cancel-icon"
                        tooltip="Cancel"
                        onPress={onCancel}
                    />
                </HStack>
            </TableCell>
        </TableRow>
    );
};

export default memo(BedForm);
